export const viewIds = {
  dashboard: "dashboard",
  expenses: "expenses",
  goals: "goals",
  reports: "reports",
  profile: "profile",
  settings: "settings"
};
